import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SpinnerComponent } from '@plugins/client/spinners';

import { LetDirective } from './let.directive';

@NgModule({
  imports: [CommonModule, SpinnerComponent],
  declarations: [LetDirective],
  exports: [LetDirective],
})
export class LetDirectiveModule {}
export { LetDirective };
